import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import { makeStyles } from "tss-react/mui"

import { createEnumChecker, iterateStringEnum } from "../../../../../../lib/enums"
import { LocalizedEnum, LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { ResourceType } from "../../../../admin/organization/resources/resourcesTypes"

// `undefined` means "All types" (no resourceType is sent to the backend).
const ALL_TYPES = "ALL"

const isResourceType = createEnumChecker(ResourceType)

type UsageResourceTypeFilterProps = Readonly<{
    value: ResourceType | undefined
    onChange: (type: ResourceType | undefined) => void
}>

const useStyles = makeStyles()(() => ({
    input: {
        width: "15rem",
    },
}))

export function UsageResourceTypeFilter({ value, onChange }: UsageResourceTypeFilterProps) {
    const { classes } = useStyles()

    return (
        <FormControl size="small" className={classes.input}>
            <LocalizedStrict id="table-select-resource-type-filter-by-label">
                <InputLabel id="usage-per-tenant-resource-type-label">Resource type</InputLabel>
            </LocalizedStrict>
            <LocalizedStrict id="table-select-resource-type-filter-by-label-label" attrs={{ label: true }}>
                <Select
                    labelId="usage-per-tenant-resource-type-label"
                    label="Resource type"
                    value={value ?? ALL_TYPES}
                    onChange={(event) => {
                        const next = event.target.value
                        onChange(isResourceType(next) ? next : undefined)
                    }}
                >
                    <MenuItem value={ALL_TYPES}>
                        <LocalizedStrict id="service-center-usage-per-tenant-resource-type-all">
                            <span>All types</span>
                        </LocalizedStrict>
                    </MenuItem>
                    {[...iterateStringEnum(ResourceType)].map((type) => (
                        <MenuItem key={type} value={type}>
                            <LocalizedEnum base="table-select-resource-type-filter-by" enumValue={type}>
                                <span>{type}</span>
                            </LocalizedEnum>
                        </MenuItem>
                    ))}
                </Select>
            </LocalizedStrict>
        </FormControl>
    )
}
